import Vue from 'vue'
import App from './App.vue'
import './global.css'
import VueRouter from 'vue-router'
import router from './page/router'
Vue.config.productionTip = false
Vue.use(VueRouter)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
